/* eslint-disable prettier/prettier */
import React, { useState } from 'react';

// material-ui
import { Chip, Button, Menu, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import AnimateButton from 'ui-component/extended/AnimateButton';

// project imports
import useLeagues from 'hooks/useLeagues';

const PoolsTitleBarActions = ({ pool }) => {
    const { deletePlayerPool } = useLeagues();

    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [confirmOpen, setConfirmOpen] = useState(false);

    const handleMenuClick = (event) => {
        setMenuAnchorEl(event.currentTarget);
    };

    const handleClose = () => setMenuAnchorEl(null);

    const handleDeletePlayerPoolButtonClick = () => {
        handleClose();
        setConfirmOpen(true);
    };

    const handleConfirmDelete = () => {
        setConfirmOpen(false);
        deletePlayerPool(pool?.id, pool?.event_instance_id);
    };

    const handleCancelDelete = () => {
        setConfirmOpen(false);
    };

    return (
        <>
            <Chip
                size="medium"
                label="Actions"
                onClick={(e) => handleMenuClick(e)}
                sx={{
                    borderRadius: '10%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            />
            <Menu
                anchorEl={menuAnchorEl}
                open={Boolean(menuAnchorEl)}
                keepMounted
                onClose={handleClose}
                variant="selectedMenu"
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
            >
                <MenuItem>
                    <AnimateButton>
                        <Button type="submit" variant="contained" color="error" onClick={handleDeletePlayerPoolButtonClick}>
                            Delete
                        </Button>
                    </AnimateButton>
                </MenuItem>
                <MenuItem onClick={() => { handleClose(); window.open(`/playing-group/schedule/${pool?.id}`, '_blank'); }}>
                    <AnimateButton>
                        <Button type="button" variant="contained" color="primary">
                            View Schedule
                        </Button>
                    </AnimateButton>
                </MenuItem>
            </Menu>
            <Dialog open={confirmOpen} onClose={handleCancelDelete}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    Are you sure you want to delete this player pool? This action cannot be undone.
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelDelete} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleConfirmDelete} color="error" variant="contained">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default PoolsTitleBarActions;
